// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
}

const IconCircleSuccess = ({ className, fill, stroke }: PropsT) => (
  <svg className={classnames('Icon IconCircleSuccess', className)} viewBox='0 0 76 76' xmlns='http://www.w3.org/2000/svg'>
    <title>success icon</title>
    <g id='Flexible-Metadata-Phase-1' strokeWidth='1' fill='none' fillRule='evenodd' opacity='0.449999988'>
      <g id='notification---successful-changes' transform='translate(-182.000000, -50.000000)'>
        <g id='panel'>
          <g id='success-icon' transform='translate(182.000000, 50.000000)'>
            <circle id='Oval-2' stroke='currentColor' strokeWidth='4' cx='38' cy='38' r='36' />
            <path d='M55.8617512,32.6948052 L37.6497696,50.461039 C35.9356254,51.9030344 33.8013721,51.9030344 31.9585253,50.461039 L22.8525346,40.4675325 C21.3587664,39.3005842 21.3587664,36.9932213 22.8525346,36.025974 C24.2029206,34.5074951 26.5135115,34.3302678 27.40553,36.025974 L35.3732719,42.6883117 L51.3087558,28.2532468 C52.8219375,26.6969979 54.9550532,27.0525885 55.8617512,28.2532468 C57.2667817,29.714406 57.2667817,31.490087 55.8617512,32.6948052 Z' id='Path' fill='#16DB85' />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default IconCircleSuccess
